import { CategoryFilter, CollaboratorFilter, StatusFilter } from '../../Filter'

const FilterMenu = () => {
  return (
    <div className='space-y-4'>
      <StatusFilter />
      <CategoryFilter />
      <CollaboratorFilter />
    </div>
  )
}

export default FilterMenu
